import React, { useState } from 'react'
import { useSnackbar } from 'notistack'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import allActions from '../../../redux/actions/user'
import TabNavigation from '../../TabNavigation/TabNavigation'

//Material UI
import TextField from '@material-ui/core/TextField'
import FormHelperText from '@material-ui/core/FormHelperText'
import { Button, Card, IconButton, Link, Modal } from '@mui/material'
import CloseIcon from '@material-ui/icons/Close'

export default function FormCoordonnees(props) {

  const dispatch = useDispatch()
  const { formClass, defaultValues, refresh, id, nextTab, previousTab } = props
  const state = useSelector(state => state)
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''
  const [modalMail, setModalMail] = useState(false)

  const { register, handleSubmit, errors } = useForm()
  const { enqueueSnackbar } = useSnackbar()


  async function save(data, e) {

    data.category = 3
    const result = await allActions.fetchPostAPI(`api/users/modifs-infos-perso/${id}`, data, dispatch, token)
    
    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (result.err) {
      enqueueSnackbar('Erreur: ' + result.err, { variant: `error` })
      return
    }

    //Si le serveur retourne une erreur elle est affiché
    if (result?.json.err) {
      enqueueSnackbar('Erreur: ' + result.json.err, { variant: `error` })
      return
    }

    enqueueSnackbar('Enregistré !', { variant: `success` })
    refresh(result.json.data)

    const action = e.nativeEvent.submitter.dataset.action
    if (action === 'previous' && previousTab) previousTab()
    else if (action === 'next') nextTab()
  }

  async function mailFormSubmit(data, e) {

    await allActions.fetchPostAPI(`api/users/change-mail/`, {
      old_mail: state.user.mail,
      new_mail: data.emailModif,
      numero: state.user.numero
    }, dispatch, token)
    enqueueSnackbar(`Un mail de confirmation a été envoyé à l'adresse ${data.emailModif}`, { variant: `success` })
    setModalMail(false)
  }

  return (
    <><form onSubmit={handleSubmit(save)}>
      <div className={formClass}>
        <TextField
          label="Mobile 1"
          variant="outlined"
          type="number"
          name="phone"
          margin="dense"
          inputRef={register({ minLength: 10, maxLength: 10, })}
          required
          error={(errors.phone !== undefined)}
          defaultValue={defaultValues?.phone}
        />
        {errors.phone && <FormHelperText error>Le numéro doit contenir 10 chiffres</FormHelperText>}


        <TextField
          label="Mobile 2"
          variant="outlined"
          type="number"
          name="mobile"
          margin="dense"
          inputRef={register({ minLength: 10, maxLength: 10, })}
          error={(errors.mobile !== undefined)}
          defaultValue={defaultValues?.mobile}
        />
        {errors.mobile && <FormHelperText error>Le numéro doit contenir 10 chiffres</FormHelperText>}

        <TextField
          label="Email"
          variant="outlined"
          type="text"
          name="email"
          margin="dense"
          inputRef={register()}
          disabled
          error={(errors.email !== undefined)}
          defaultValue={defaultValues?.email}
          required
        />
        {errors.email && <FormHelperText error>{errors.email.message}</FormHelperText>}
        <Link
          underline="none"
          sx={{ cursor: 'pointer', userSelect: 'none' }}
          onClick={() => setModalMail(true)}
        >{!defaultValues?.email ? 'Affecter une adresse mail' : 'Changer son adresse mail'}</Link>
      </div>

      <TabNavigation save previous next/>

      
    </form>
    <Modal open={modalMail} onClose={() => setModalMail(false)} sx={{ display: 'grid', placeContent: 'center' }}>
      <Card sx={{ width: 300, p: 2 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16, alignItems: 'center' }}>
          <h3 style={{ margin: 0 }}>Changez votre adresse mail</h3>
          <IconButton size="small" onClick={() => setModalMail(false)}><CloseIcon /></IconButton>
        </div>
        
        <form onSubmit={handleSubmit(mailFormSubmit)}>
          <TextField
            label="email"
            variant="outlined"
            type="text"
            name="emailModif"
            margin="dense"
            inputRef={register({
              pattern: {
                value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: 'Adresse email invalide'
              }
            })}
            error={(errors.emailModif !== undefined)}
            defaultValue={defaultValues?.email}
            fullWidth
          />
          {errors.emailModif && <FormHelperText error>{errors.emailModif.message}</FormHelperText>}
          <Button type="submit" sx={{ mt: 1 }} fullWidth variant='contained' disableElevation>Mettre à jour</Button>

        </form>
        
      </Card>
    </Modal>
    </>
    
  )
}
